import React from 'react';
export function PainPointsSection() {
  return <section className="w-full bg-gray-50 py-10 px-4 md:px-8" data-id="element-118">
      <div className="max-w-3xl mx-auto space-y-5 text-lg text-gray-800 leading-relaxed" data-id="element-119">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6" data-id="element-120">
          Si sos maestra de primaria, esto te va a sonar familiar…
        </h2>

        <p data-id="element-121">Llegás a casa agotada… y todavía tenés que planificar.</p>

        <p data-id="element-122">
          Horas armando clases de Lengua, Matemática, Ciencias Sociales y
          Ciencias Naturales.
        </p>

        <p data-id="element-123">
          Buscando actividades que enganchen. Tratando de organizar los
          contenidos por grado. Imprimiendo cosas sueltas. Rearmando lo que no
          te convenció.
        </p>

        <div className="bg-white p-5 rounded-lg shadow-sm border-l-4 border-red-500 my-4" data-id="element-124">
          <p className="font-bold text-xl mb-1" data-id="element-125">
            No es falta de vocación. No es falta de capacidad.
          </p>
          <p data-id="element-126">
            Es que te falta un sistema completo que te sostenga todo el año.
          </p>
        </div>
      </div>
    </section>;
}